import * as React from 'react'
import { defineMessages, FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import styles from './faq.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: 'FAQ - Dina frågor besvarade',
    id: 'free.faq.heading',
  },
  question1: {
    defaultMessage: 'Fungerar Dooer på både PC och Mac?',
    id: 'free.faq.question-1',
  },
  answer1: {
    defaultMessage:
      'Ja, du arbetar med Dooer Fakturering i din webbläsare och tjänsten fungerar i alla vanligt förekommande webbläsare som Chrome, Safari, Microsoft Edge och Firefox.',
    id: 'free.faq.answer-1',
  },
  question2: {
    defaultMessage: 'Kan jag skicka fakturan med vanlig post?',
    id: 'free.faq.question-4',
  },
  answer2: {
    defaultMessage:
      'Ja, genom att ladda ner och skriva ut fakturan själv kan du skicka den som det passar dig och din kund. När du skapat och ska skicka fakturan välj alternativet Skriv ut på egen skrivare. Då skickas inte fakturan av Dooer utan du får ladda ner fakturan som PDF och kan välja att skriva ut den eller skicka den som PDF själv.',
    id: 'free.faq.answer-4',
  },
  question3: {
    defaultMessage: 'Jag har redan en fakturanummerserie, kan jag flytta in den i Dooer Fakturering?',
    id: 'free.faq.question-2',
  },
  answer3: {
    defaultMessage:
      'Ja, du kan ange vilket nästa fakturanummer ska vara i Dooer Fakturering när du börjar använda tjänsten och på så sätt kan du behålla en obruten fakturanummerserie.',
    id: 'free.faq.answer-2',
  },
  question4: {
    defaultMessage: 'Kan jag fakturera med olika momssatser?',
    id: 'free.faq.question-5',
  },
  answer4: {
    defaultMessage:
      'Ja, för varje artikel du lägger till i artikelregistret anger du den momssats som ska tillämpas för den artikeln. Vald momssats tillämpas automatisk när du skapar fakturor med artikeln.',
    id: 'free.faq.answer-5',
  },
  question5: {
    defaultMessage: 'Kan jag skicka fakturor på engelska?',
    id: 'free.faq.question-6',
  },
  answer5: {
    defaultMessage:
      'Ja, du kan skicka fakturor på svenska och engelska med Dooer Fakturering. Du kan även ställa in att olika kunder automatiskt ska få fakturor i olika språk.',
    id: 'free.faq.answer-6',
  },
  question6: {
    defaultMessage: 'Kan jag fakturera med omvänd skattskyldighet?',
    id: 'free.faq.question-8',
  },
  answer6: {
    defaultMessage:
      'Ja, när du skapar en faktura kan du välja att omvänd skattskyldighet ska tillämpas. När det valet är aktivt adderas ingen moms till fakturan oavsett konfigurerad momssats på artiklarna du fakturerar.',
    id: 'free.faq.answer-8',
  },
})

const qas = [
  {
    q: messages.question1,
    a: messages.answer1,
  },
  {
    q: messages.question2,
    a: messages.answer2,
  },
  {
    q: messages.question3,
    a: messages.answer3,
  },
  {
    q: messages.question4,
    a: messages.answer4,
  },
  {
    q: messages.question5,
    a: messages.answer5,
  },
  {
    q: messages.question6,
    a: messages.answer6,
  },
]

export default function Faq() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <FormattedHTMLMessage tagName="h2" {...messages.heading} />
        <div className={styles.items}>
          {qas.map((item) => (
            <div key={item.q.defaultMessage}>
              <FormattedMessage tagName="h4" {...item.q} />
              <FormattedMessage tagName="p" {...item.a} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
